import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// Import errorHandler before App so Bugsnag.start runs (with the env-aware
// releaseStage and the postMessage noise filter) before any app code can
// throw. This is also the single Bugsnag startup path — Wrapper.js consumes
// the same ErrorBoundary export.
import { ErrorBoundary } from './utils/errorHandler';
import App from './components/layout/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

serviceWorkerRegistration.unregister();

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);

// serviceWorkerRegistration.register();
reportWebVitals();
